var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-breadcrumb',{staticClass:"app-breadcrumb",staticStyle:{"height":"50px","backgroundColor":"rgba(255, 0, 0, 0)","borderRadius":"4px","padding":"0px 20px 0px 20px","boxShadow":"0px 0px 0px #f903d4","borderWidth":"0","borderStyle":"solid","borderColor":"rgba(255, 215, 0, 1)"},attrs:{"separator":"//"}})
}
var staticRenderFns = []

export { render, staticRenderFns }